import { HStack, VStack } from '../../Stack';

/**
 * 페이지 안에서 사용하는 높이 고정된 가로 컨테이너.
 *
 * 패딩, 높이, 배경, 정렬.
 */
export const ContainerH = (props: React.ComponentProps<typeof HStack>) => {
  return <HStack p={2} bgcolor={'white'} alignItems={'center'} {...props} />;
};

/**
 * 페이지 안에서 사용하는 세로 컨테이너.
 *
 * 패딩, 배경.
 */
export const ContainerV = (props: React.ComponentProps<typeof VStack>) => {
  return <VStack p={2} bgcolor={'white'} {...props} />;
};
